import type * as Types from '../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetWelcomePageInfoForWebsiteTemplateQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetWelcomePageInfoForWebsiteTemplateQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    welcomePageInfo?: {
      __typename?: 'EventPageInfo';
      id: string;
      type: Types.EventPageType;
      page: {
        __typename?: 'EventPage';
        id: string;
        photoV2?:
          | {
              __typename?: 'DefaultPagePhoto';
              id: string;
              url: string;
              assetId: string;
              width: number;
              height: number;
              layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string };
            }
          | {
              __typename?: 'Photo';
              id: string;
              url: string;
              assetId: string;
              width: number;
              height: number;
              layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
            }
          | null;
        photoPresentation?: {
          __typename?: 'WebsitePagePhotoPresentation';
          id: string;
          presentationLayout: string;
          cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; height: number; width: number; unit: string; x: number; y: number } | null;
          photo?: {
            __typename?: 'Photo';
            id: string;
            url: string;
            assetId: string;
            width: number;
            height: number;
            layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
          } | null;
        } | null;
      };
    } | null;
  } | null;
};

export type UpdateWelcomePagePhotoPresentationLayoutMutationVariables = Types.Exact<{
  payload: Types.websiteCreateOrUpdatePagePhotoPresentationPayload;
}>;

export type UpdateWelcomePagePhotoPresentationLayoutMutation = {
  __typename?: 'Mutation';
  websiteCreateOrUpdatePagePhotoPresentation?:
    | { __typename?: 'websiteCreateOrUpdatePagePhotoPresentationResponse'; success: boolean; message: string }
    | { __typename?: 'websiteCreateOrUpdatePagePhotoPresentationResponseError'; id?: string | null; message: string; success: boolean }
    | null;
};

export type ApplyWebsiteTemplateSettingsMutationVariables = Types.Exact<{
  payload: Types.ApplyWebSiteTemplateSettingsPayload;
}>;

export type ApplyWebsiteTemplateSettingsMutation = {
  __typename?: 'Mutation';
  applyWebSiteTemplateSettings: {
    __typename?: 'EventDesign';
    id: string;
    activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; schemaURL: string; websiteLayout: string; dataJSON: any; id: string } | null;
  };
};

export const GetWelcomePageInfoForWebsiteTemplateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWelcomePageInfoForWebsiteTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'welcomePageInfo' },
                  name: { kind: 'Name', value: 'pageInfo' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'EnumValue', value: 'welcome' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'page' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photoV2' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'layout' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'layout' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photoPresentation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cropInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'photo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'layout' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWelcomePageInfoForWebsiteTemplateQuery__
 *
 * To run a query within a React component, call `useGetWelcomePageInfoForWebsiteTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelcomePageInfoForWebsiteTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelcomePageInfoForWebsiteTemplateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetWelcomePageInfoForWebsiteTemplateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>(
    GetWelcomePageInfoForWebsiteTemplateDocument,
    baseOptions,
  );
}
export function useGetWelcomePageInfoForWebsiteTemplateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>(
    GetWelcomePageInfoForWebsiteTemplateDocument,
    baseOptions,
  );
}
export type GetWelcomePageInfoForWebsiteTemplateQueryHookResult = ReturnType<typeof useGetWelcomePageInfoForWebsiteTemplateQuery>;
export type GetWelcomePageInfoForWebsiteTemplateLazyQueryHookResult = ReturnType<typeof useGetWelcomePageInfoForWebsiteTemplateLazyQuery>;
export type GetWelcomePageInfoForWebsiteTemplateQueryResult = Apollo.QueryResult<GetWelcomePageInfoForWebsiteTemplateQuery, GetWelcomePageInfoForWebsiteTemplateQueryVariables>;
export const UpdateWelcomePagePhotoPresentationLayoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWelcomePagePhotoPresentationLayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'websiteCreateOrUpdatePagePhotoPresentationPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteCreateOrUpdatePagePhotoPresentation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'websiteCreateOrUpdatePagePhotoPresentationResponse' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'websiteCreateOrUpdatePagePhotoPresentationResponseError' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateWelcomePagePhotoPresentationLayoutMutationFn = Apollo.MutationFunction<
  UpdateWelcomePagePhotoPresentationLayoutMutation,
  UpdateWelcomePagePhotoPresentationLayoutMutationVariables
>;

/**
 * __useUpdateWelcomePagePhotoPresentationLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateWelcomePagePhotoPresentationLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWelcomePagePhotoPresentationLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWelcomePagePhotoPresentationLayoutMutation, { data, loading, error }] = useUpdateWelcomePagePhotoPresentationLayoutMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateWelcomePagePhotoPresentationLayoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWelcomePagePhotoPresentationLayoutMutation, UpdateWelcomePagePhotoPresentationLayoutMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateWelcomePagePhotoPresentationLayoutMutation, UpdateWelcomePagePhotoPresentationLayoutMutationVariables>(
    UpdateWelcomePagePhotoPresentationLayoutDocument,
    baseOptions,
  );
}
export type UpdateWelcomePagePhotoPresentationLayoutMutationHookResult = ReturnType<typeof useUpdateWelcomePagePhotoPresentationLayoutMutation>;
export type UpdateWelcomePagePhotoPresentationLayoutMutationResult = Apollo.MutationResult<UpdateWelcomePagePhotoPresentationLayoutMutation>;
export type UpdateWelcomePagePhotoPresentationLayoutMutationOptions = Apollo.BaseMutationOptions<
  UpdateWelcomePagePhotoPresentationLayoutMutation,
  UpdateWelcomePagePhotoPresentationLayoutMutationVariables
>;
export const ApplyWebsiteTemplateSettingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplyWebsiteTemplateSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplyWebSiteTemplateSettingsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyWebSiteTemplateSettings' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApplyWebsiteTemplateSettingsMutationFn = Apollo.MutationFunction<ApplyWebsiteTemplateSettingsMutation, ApplyWebsiteTemplateSettingsMutationVariables>;

/**
 * __useApplyWebsiteTemplateSettingsMutation__
 *
 * To run a mutation, you first call `useApplyWebsiteTemplateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyWebsiteTemplateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyWebsiteTemplateSettingsMutation, { data, loading, error }] = useApplyWebsiteTemplateSettingsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useApplyWebsiteTemplateSettingsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyWebsiteTemplateSettingsMutation, ApplyWebsiteTemplateSettingsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<ApplyWebsiteTemplateSettingsMutation, ApplyWebsiteTemplateSettingsMutationVariables>(ApplyWebsiteTemplateSettingsDocument, baseOptions);
}
export type ApplyWebsiteTemplateSettingsMutationHookResult = ReturnType<typeof useApplyWebsiteTemplateSettingsMutation>;
export type ApplyWebsiteTemplateSettingsMutationResult = Apollo.MutationResult<ApplyWebsiteTemplateSettingsMutation>;
export type ApplyWebsiteTemplateSettingsMutationOptions = Apollo.BaseMutationOptions<ApplyWebsiteTemplateSettingsMutation, ApplyWebsiteTemplateSettingsMutationVariables>;
